import React from 'react'
import { View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { StatusBar, StatusBarStyle } from 'expo-status-bar'

import { Palette } from '@ppwr/poker'
import { DS } from '@/design-system'

import { AvatarCreator } from '@/screens/profile-screen/edit/AvatarCreator'

export const CreateAvatarScreen = () => {
  return (
    <SafeAreaView style={{ backgroundColor: Palette['Brand/Cream'], flex: 1 }}>
      <StatusBar animated={true} style={'dark' as StatusBarStyle} hidden={false} />
      <View style={{ flex: 1, paddingHorizontal: 24, paddingBottom: 16, gap: 20 }}>
        <View style={{ paddingTop: 16 }}>
          <DS.Text variant="Heading 2/Regular" textAlign="center">
            Create your profile
          </DS.Text>
        </View>
        <AvatarCreator />
      </View>
    </SafeAreaView>
  )
}
